var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSavr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1403_1893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9916 15.6213L13.9332 14.5786L7.46815 21.0758L13.9867 27.4977L15.5755 25.9009C15.698 26.1752 15.8728 26.4317 16.1001 26.6556C17.0819 27.6228 18.6673 27.6136 19.641 26.6351C20.6148 25.6565 20.6083 24.0789 19.6265 23.1117C19.3992 22.8878 19.1397 22.7164 18.8628 22.5973L20.4517 21.0005L19.3933 19.9578C18.1708 20.6318 16.5983 20.4592 15.5575 19.4339C14.5155 18.4072 14.3264 16.8444 14.9916 15.6213Z",
    fill: "#1ECAD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4839 12.997L17.0778 14.5832C16.8034 14.706 16.5466 14.8813 16.3224 15.1089C15.3537 16.0923 15.3602 17.6776 16.3371 18.6497C17.3139 19.6217 18.8913 19.6126 19.86 18.6293C20.0842 18.4017 20.2561 18.1418 20.3756 17.8648L21.9695 19.451L23.0633 18.3406C22.5136 17.151 22.7227 15.6895 23.6952 14.7024C24.6676 13.7152 26.1197 13.4905 27.3087 14.0313L28.4025 12.9209L21.917 6.46696L15.4839 12.997Z",
    fill: "#1ECAD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4442 16.0156C28.3321 15.816 28.1913 15.6277 28.0193 15.4595C27.0375 14.4922 25.452 14.5014 24.4783 15.48C23.5046 16.4586 23.5111 18.0361 24.4929 19.0034C24.6649 19.1728 24.8543 19.3111 25.056 19.4207L23.517 20.9674L24.726 22.1585C25.9486 21.4845 27.521 21.6571 28.5618 22.6824C29.6026 23.7078 29.7917 25.2694 29.1265 26.4938L30.0355 27.3893L36.5005 20.8921L29.982 14.4702L28.4442 16.0156Z",
    fill: "#1ECAD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2673 23.4873C24.0428 23.715 23.8708 23.9748 23.7511 24.2519L22.005 22.5162L20.9593 23.5765C21.632 24.7981 21.4567 26.3711 20.4284 27.4137C19.4001 28.4564 17.8363 28.648 16.6116 27.9848L15.5659 29.0451L22.06 35.5002L28.5003 28.9701L27.0544 27.5329C27.3292 27.41 27.5863 27.2347 27.8108 27.007C28.7808 26.0235 28.7743 24.4379 27.7961 23.4656C26.8168 22.4946 25.2374 22.5038 24.2673 23.4873Z",
    fill: "#1ECAD2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1403_1893",
    x: 3.46875,
    y: 6.4668,
    width: 37.0312,
    height: 37.0337,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1403_1893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1403_1893",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavr);
export default __webpack_public_path__ + "static/media/savr.294a4852561f09c59b28ad7083bbc437.svg";
export { ForwardRef as ReactComponent };